export default __webpack_public_path__ + "static/media/br-wifi.db63fa01.svg";